module.exports = __webpack_public_path__ + "images/emoji/telescope.155384ee6f811497ef9c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/telescope.png
// module id = qCoc
// module chunks = 13